<template>
    <div>
        <formulario :aspirante="aspirante_data" :lista_estudios="lista_estudios" :certificado_adjunto="certificado_adjunto" :curriculum_adjunto="curriculum_adjunto"></formulario>
    </div>

</template>

<script>

import Formulario from './Formulario.vue'
import Layout from '@/Shared/Layout'
import Description from './Description'

export default {
    components: {
        Formulario
    },
    layout: Layout,
    props: {
        aspirante: Object,
        lista_estudios:Object,
        curriculum_adjunto:Object,
        certificado_adjunto:Object,
    },
    remember: 'form',
    watch: {
        '$page.props.verificado':function (newError, oldError) {
            if(Object.keys(newError).length > 0){
                const h = this.$createElement;
                this.$msgbox({
                    title: 'Message',
                    message: h('p', null, [
                        h('span', null, 'El formulario contiene los siguientes errores: '),
                        h('br', null, ),
                        h('i', { style: 'color: teal' },
                            Object.values(newError)
                        )
                    ]),
                    confirmButtonText: 'OK',
                });
            }

        }
    },

    created (){
        //console.log('this.aspirante.length', this.aspirante.length)
        if (this.aspirante){
            this.aspirante_data = this.aspirante;
        }

    },
    data() {
        return {
            aspirante_data: {
                id:null,
                nombre: null,
                apellido: null,
                tipo_documento_id: null,
                numero_documento: null,
                cuit_cuil:null,
                correo_electronico: null,
                fecha_de_nacimiento: null,
                curriculum_adjunto:null,

                certificado_de_discapacidad: null,
                tipodiscapacidad: null,
                adaptaciones_o_necesidades_requeridas: null,
                domicilioConstituido_calle : null,
                domicilioConstituido_numero : null,
                domicilioConstituido_piso : null,
                domicilioConstituido_departamento : null,
                domicilioConstituido_codigo_postal : null,
                domicilioConstituido_localidad : null,
                domicilioConstituido_telefono : null,

                experiencia_judicial : null,
                detalle_exp_judicial : null,
                auxiliar : null,
                auxiliar_de_servicio : null,

                estudio_id : null,
                universitario_descripcion : null,
                tipoestudio : null,

                intereses : null,
                estudio:null,
                tipo_documento:null,

                cursosCfj:null,
            },
            options: [{
                value: 'true',
                label: 'SI'
            }, {
                value: 'false',
                label: 'NO'
            }],
            // lista_estudios: [{
            //     value: '2',
            //     label: 'ABOGACIA'
            // },
            // {
            //     value: '3',
            //     label: 'MARTILLERO PUBLICO'
            // }],
            lista_documento: [{
                value: '1',
                label: 'DNI'
            },
            {
                value: '2',
                label: 'PASAPORTE'
            }],
        }
    },
    mounted(){

    },
    methods: {
        update() {
            this.form.put(this.route('aspirantes.update', this.aspirante.id))
        },
    },
}
</script>
